import { t } from '@lingui/macro';

export function getNoDimensionTranslation(dimensionName: string) {
    return t`No ${dimensionName}`;
}
